import React from 'react';

import { Picker, Text, TypographyHeading } from '..';
import { TextInputEditInPlace } from '../input';

const SIGN_IN_OPTIONS = [
	{ label: 'Yes', value: 'yes' },
	{ label: 'No', value: 'no' },
];

const LocationSignInDetails = ({ location, canEdit = false, onConfirm }) => {
	const selectedValue = location?.requiresSignIn === true
		? 'yes'
		: location?.requiresSignIn === false ? 'no' : null;

	return (
		<>
			<TypographyHeading
				fieldLabel={true}
				label="Requires site sign-in"
			/>
			{canEdit ? (
				<Picker
					accessibilityLabel="Requires site sign-in"
					options={SIGN_IN_OPTIONS}
					selectedValue={selectedValue}
					emptyValueLabel="Not recorded"
					onValueChange={value => onConfirm({ requiresSignIn: value === 'yes' })}
					width={180}
				/>
			) : (
				<Text>{selectedValue === 'yes' ? 'Yes' : selectedValue === 'no' ? 'No' : 'Not recorded'}</Text>
			)}
			{location?.requiresSignIn === true && (
				<>
					<TypographyHeading
						fieldLabel={true}
						label="Site sign-in instructions"
					/>
					<TextInputEditInPlace
						value={location.signInInstructions}
						placeholder="None specified"
						field="signInInstructions"
						disabled={!canEdit}
						onConfirm={onConfirm}
						multiline={true}
						numberOfLines={4}
					/>
				</>
			)}
		</>
	);
};

export default LocationSignInDetails;
